import React, { useState, useEffect } from 'react';
import './Cookies.css';

const Cookies: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookies-popup">
      <div className="cookies-text">
        <p>
          Wygodne korzystanie ze strony wymaga włączenia obsługi cookie w przeglądarce. 
          Pliki cookie wygasają po zamknięciu sesji.
        </p>
        <a href="/polityka-cookies">Więcej informacji</a>
      </div>
      <button className="cookies-close-btn" onClick={handleAccept}>
        Ok, rozumiem!
      </button>
    </div>
  );
};

export default Cookies;
